import { BrandedBackgroundContainer, StyledButton } from '@components/core';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useLogout from '@src/hooks/use-logout';
import { StyledPaper } from '@styled/styled-paper';
import React, { useEffect } from 'react';

export default function AuthErrorPage({
  resetErrorBoundary,
}: {
  resetErrorBoundary: () => void;
}) {
  const { handleLogout, isSuccess } = useLogout();

  useEffect(() => {
    if (isSuccess) {
      window.location.assign(`${window.location.origin}/login`);
    }
  }, [isSuccess]);

  return (
    <BrandedBackgroundContainer>
      <Box
        display='flex'
        height='100vh'
        width='100%'
        alignItems='center'
        justifyContent='center'
      >
        <StyledPaper>
          <Box
            margin='auto'
            display='flex'
            flexDirection='column'
            gap={1}
            p={4}
          >
            <Typography variant='h6' margin='auto'>
              There was an error authenticating the user
            </Typography>
            <StyledButton
              pill
              variant='contained'
              onClick={() => resetErrorBoundary()}
            >
              Retry
            </StyledButton>
            <StyledButton
              pill
              variant='contained'
              onClick={() => handleLogout()}
            >
              Sign out
            </StyledButton>
          </Box>
        </StyledPaper>
      </Box>
    </BrandedBackgroundContainer>
  );
}
